import { DatePipe } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import * as _ from "lodash";
import * as fromRootStore from "../../../reducers";
import {
  Combo2Service,
  ExcelService,
  PurchaseReportService
} from "../../../services/index";
declare var google;

@Component({
  selector: "work-order-delivery-pending",
  templateUrl: "./woFabricDeliveryPending.html"
})
export class woFabricDeliveryPending implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  filter = {
    finyear: "",
    status: "PENDING",
    from_date: "",
    to_date: "",
    fin_id: ""
  };
  statusList = ["PENDING", "ALL"];
  gridOptions: any;
  isLoadMask: Promise<any>;
  loadingIndicator: boolean = true;
  finyearList = [];
  exceldata: any;
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "wo_no",
    orderDir: "asc"
  };
  printConfig: any = {
    title: "Work Order Vs Fab Pending",
    columns: [],
    rows: []
  };

  partyList = [];

  finyearCtrl: FormControl = new FormControl();
  columns = [];
  constructor(
    public store: Store<fromRootStore.State>,
    private excelService: ExcelService,
    private purReport: PurchaseReportService,
    public datePipe: DatePipe,
    private combo2Service: Combo2Service
  ) {
    var today = new Date();
    var priorDate = new Date().setDate(today.getDate() - 30);
    this.filter.from_date = new Date(priorDate).toISOString();
  }

  ngOnInit(): void {
    this.finyearCombo();
    this.getWoFabPending();
  }

  exportToExcel($event) {
    this.excelService.exportAsExcelFile(this.exceldata, this.title);
  }

  finyearCombo() {
    let that = this;
    this.combo2Service.finyearCombo().then((res: any) => {
      that.finyearList = res.data;
      that.finyearList.forEach(el => {
        if (
          that.filter.from_date > el.start_date &&
          that.filter.from_date < el.end_date
        ) {
          that.filter.fin_id = el.fin_id;
        }
      });
      that.finyearCtrl.setValue(that.filter.fin_id);
    });
  }
  displayFinyear(comboType: string, id: number) {
    let list: any = [];
    if (comboType == "Finyear") {
      list = this.finyearList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { fin_id: id });
      return fitem["finyear"];
    }
    return "";
  }

  getWoFabPending(): void {
    this.filter.from_date = this.datePipe.transform(
      this.filter.from_date,
      "yyyy-MM-dd"
    );
    this.filter.to_date = this.datePipe.transform(
      this.filter.to_date,
      "yyyy-MM-dd"
    );
    let params = {
      filter: JSON.stringify(this.filter)
    };
    let that = this;
    that.gridOptions = {
      loading: true,
      columns: []
    };
    this.isLoadMask = this.purReport
      .getWoFabPending(params)
      .then(function(res: any) {
        that.loadingIndicator = false;

        that.gridOptions = {
          cols: res.cols,
          columns: res.columns,
          data: res.data,
          loading: false
        };
        that.printConfig = {
          title: "Work Order Vs Fab Pending",
          columns: res.columns,
          rows: res.data
        };
        that.exceldata = that.getData(res.columns, res.data);
      });
  }

  getData(columns, data) {
    let cols = columns;
    let value = data;
    let rows = [],
      row,
      ind,
      type,
      val,
      rlen = data.length,
      clen = columns.length;

    for (let i = 0; i < data.length; i++) {
      let sno = i + 1;
      row = Object.assign({}, data[i]);
      let newrow = {
        Sno: sno
      };
      for (let j = 1; j < clen; j++) {
        let type = cols[j].type,
          index = cols[j].index,
          prop = cols[j].prop,
          name = cols[j].name;

        newrow[name] = row[prop];
      }

      rows.push(newrow);
      sno++;
    }
    return rows;
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/woreports/woFabricDeliveryPending.ts